export default __webpack_public_path__ + "static/media/banner@2x.c4d9996c.jpg";